var _linearGradient, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.753,
    x2: 524.202,
    y1: 401.161,
    y2: 103.566
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcfdee",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6288,
    stopColor: "#d2f3e4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m418.32 2.5c-55.666-9.521-178.298 12.183-200.004 105.017-14.431 61.722-14.007 112.075-50.427 113.02-21.67.562-32.97-44.31-62.889-48.001-39.047-4.817-66.145 27.695-83.057 57.138-37.205 64.772-25.571 174.918 23.354 228.632 118.488 130.086 259.197-5.952 319.358-112.309 38.585-68.213 125.637-123.352 143.767-200.248 15.177-64.376-18.503-131.003-90.102-143.249z",
    fill: "url(#SVGID_1_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m455.47 452.133h-398.94c-8.284 0-15-6.716-15-15v-314.266c0-8.284 6.716-15 15-15h398.94c8.284 0 15 6.716 15 15v314.266c0 8.285-6.715 15-15 15z",
    fill: "#2626bc",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.47 98.87v314.26c0 8.29-6.72 15-15 15h-398.94c-8.28 0-15-6.71-15-15v-314.26c0-8.29 6.72-15 15-15h398.94c8.28 0 15 6.71 15 15z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m315.474 258.633h-71.851c-3.097 0-5.607-2.51-5.607-5.607v-71.851c0-3.097 2.51-5.607 5.607-5.607h71.851c3.097 0 5.607 2.51 5.607 5.607v71.851c0 3.096-2.51 5.607-5.607 5.607z",
    fill: "#01eca5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.67 258.633h-71.851c-3.097 0-5.607-2.51-5.607-5.607v-71.851c0-3.097 2.51-5.607 5.607-5.607h71.851c3.097 0 5.607 2.51 5.607 5.607v71.851c0 3.096-2.51 5.607-5.607 5.607z",
    fill: "#9fb0fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m315.474 364.404h-71.851c-3.097 0-5.607-2.51-5.607-5.607v-71.851c0-3.097 2.51-5.607 5.607-5.607h71.851c3.097 0 5.607 2.51 5.607 5.607v71.851c0 3.097-2.51 5.607-5.607 5.607z",
    fill: "#ffa8cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.67 364.404h-71.851c-3.097 0-5.607-2.51-5.607-5.607v-71.851c0-3.097 2.51-5.607 5.607-5.607h71.851c3.097 0 5.607 2.51 5.607 5.607v71.851c0 3.097-2.51 5.607-5.607 5.607z",
    fill: "#01eca5"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m321.08 392.72v35.41h-83.06v-35.41c0-3.1 2.51-5.61 5.6-5.61h71.85c3.1 0 5.61 2.51 5.61 5.61z",
    fill: "#b7c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.28 392.72v35.41h-83.07v-35.41c0-3.1 2.51-5.61 5.61-5.61h71.85c3.1 0 5.61 2.51 5.61 5.61z",
    fill: "#02ffb3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m203.623 83.867h-147.093c-8.284 0-15 6.716-15 15v314.266c0 8.284 6.716 15 15 15h147.094v-344.266z",
    fill: "#ff7eb8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.53 281.442h162.094v79.963h-162.094z",
    fill: "#ffa8cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.47 153.18v-54.313c0-8.284-6.716-15-15-15h-398.94c-8.284 0-15 6.716-15 15v54.313z",
    fill: "#8399fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.47 433.133h-398.94c-11.028 0-20-8.972-20-20v-314.266c0-11.028 8.972-20 20-20h398.94c11.028 0 20 8.972 20 20v314.266c0 11.028-8.972 20-20 20zm-398.94-344.266c-5.514 0-10 4.486-10 10v314.266c0 5.514 4.486 10 10 10h398.94c5.514 0 10-4.486 10-10v-314.266c0-5.514-4.486-10-10-10z",
    fill: "#2626bc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 85.623,
    cy: 120.768,
    fill: "#ff5ba8",
    r: 10.901
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.424,
    cy: 120.768,
    fill: "#fff",
    r: 10.901
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.224,
    cy: 120.768,
    fill: "#02ffb3",
    r: 10.901
  })), /*#__PURE__*/React.createElement("path", {
    d: "m432.277 133.015h-136.158v-24.495h136.159c2.761 0 5 2.239 5 5v14.496c-.001 2.761-2.239 4.999-5.001 4.999z",
    fill: "#d2deff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.789 108.831c-5.286-5.286-13.887-5.286-19.173 0s-5.286 13.887 0 19.173c4.037 4.037 10.003 4.98 14.953 2.852l4.348 4.348c1.952 1.952 5.119 1.952 7.071 0s1.952-5.119 0-7.071l-4.348-4.348c2.129-4.951 1.186-10.917-2.851-14.954zm-12.102 7.071c1.387-1.387 3.644-1.387 5.031 0s1.387 3.644 0 5.031-3.644 1.387-5.031 0-1.387-3.644 0-5.031z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m129.578 334.786h-56.181c-2.761 0-5 2.239-5 5s2.239 5 5 5h56.181c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 74.722,
    cy: 177.569,
    fill: "#fff",
    r: 5.002
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 74.722,
    cy: 196.733,
    fill: "#fff",
    r: 5.002
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m197.071 58.223c-2.761 0-5-2.238-5-5 0-3.309-2.691-6-6-6-2.761 0-5-2.238-5-5s2.239-5 5-5c3.309 0 6-2.691 6-6 0-2.762 2.239-5 5-5s5 2.238 5 5c0 3.309 2.691 6 6 6 2.761 0 5 2.238 5 5s-2.239 5-5 5c-3.309 0-6 2.691-6 6 0 2.761-2.239 5-5 5z",
    fill: "#01eca5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.548 491.464c-2.761 0-5-2.238-5-5 0-3.309-2.691-6-6-6-2.761 0-5-2.238-5-5s2.239-5 5-5c3.309 0 6-2.691 6-6 0-2.762 2.239-5 5-5s5 2.238 5 5c0 3.309 2.691 6 6 6 2.761 0 5 2.238 5 5s-2.239 5-5 5c-3.309 0-6 2.691-6 6 0 2.762-2.238 5-5 5z",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.66 61.98c-2.761 0-5-2.238-5-5 0-3.309-2.691-6-6-6-2.761 0-5-2.238-5-5s2.239-5 5-5c3.309 0 6-2.691 6-6 0-2.762 2.239-5 5-5s5 2.238 5 5c0 3.309 2.691 6 6 6 2.761 0 5 2.238 5 5s-2.239 5-5 5c-3.309 0-6 2.691-6 6 0 2.762-2.239 5-5 5z",
    fill: "#ff5ba8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321.08 489.756c-7.88 0-14.292-6.411-14.292-14.292 0-7.88 6.411-14.291 14.292-14.291s14.292 6.411 14.292 14.291c0 7.881-6.412 14.292-14.292 14.292zm0-18.583c-2.366 0-4.292 1.925-4.292 4.291s1.925 4.292 4.292 4.292 4.292-1.926 4.292-4.292-1.926-4.291-4.292-4.291z",
    fill: "#ff5ba8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.84 60.271c-7.88 0-14.292-6.411-14.292-14.291 0-7.881 6.411-14.292 14.292-14.292s14.292 6.411 14.292 14.292c0 7.88-6.411 14.291-14.292 14.291zm0-18.583c-2.366 0-4.292 1.926-4.292 4.292s1.925 4.291 4.292 4.291 4.292-1.925 4.292-4.291-1.925-4.292-4.292-4.292z",
    fill: "#6583fe"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService2);
export default __webpack_public_path__ + "static/media/service2.502a022ae6f91092e6e52b630aedece1.svg";
export { ForwardRef as ReactComponent };